<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="扫码支付"
    width="500px"
    @close="handleClose"
  >
    <div class="qr-container">
      <!-- 有有效二维码文本时显示画布 -->
      <canvas
        v-if="hasValidQrText"
        ref="qrCanvas"
        width="200"
        height="200"
        style="width: 200px; height: 200px"
      ></canvas>
      <!-- 无有效二维码文本时显示提示 -->
      <div v-else class="empty-tip">
        <i class="el-icon-warning-outline"></i>
        <p>暂无可支付的二维码</p>
      </div>
    </div>
    <p class="tip">请使用微信扫描二维码支付,20次方案任意下载</p>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveQrCode">保存图片</el-button>
    </span>
  </el-dialog>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "CodeDialogComponent",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    qrText: {
      type: String,
      default: "", // 改为空字符串，不再提供示例URL，由父组件传入真实内容
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    // 判断是否有有效的二维码文本
    hasValidQrText() {
      return this.qrText && this.qrText.trim() !== "";
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val && this.hasValidQrText) {
          this.$nextTick(() => this.generateQRCode());
        }
      },
    },
    qrText: {
      handler() {
        if (this.dialogVisible && this.hasValidQrText) {
          this.generateQRCode();
        }
      },
    },
  },
  methods: {
    async generateQRCode() {
      const canvas = this.$refs.qrCanvas;
      // 双重校验：没有canvas或没有有效文本则退出
      if (!canvas || !this.hasValidQrText) {
        return;
      }

      try {
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        await QRCode.toCanvas(canvas, this.qrText, {
          width: 200,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#ffffff",
          },
        });
      } catch (err) {
        console.error("生成二维码失败", err);
        this.$message.error("生成二维码失败");
      }
    },
    saveQrCode() {
      // 如果当前没有有效文本，直接提示
      if (!this.hasValidQrText) {
        this.$message.warning("暂无可保存的二维码");
        return;
      }
      const canvas = this.$refs.qrCanvas;
      if (!canvas) {
        this.$message.warning("二维码未生成");
        return;
      }
      const link = document.createElement("a");
      link.download = "qrcode.png";
      link.href = canvas.toDataURL();
      link.click();
      this.$message.success("图片已保存");
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.qr-container {
  text-align: center;
  padding: 20px;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tip {
  text-align: center;
  color: #666;
  font-size: 12px;
  margin-top: 10px;
}
.empty-tip {
  color: #999;
  text-align: center;
  i {
    font-size: 48px;
    display: block;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
}
</style>
